import { ComponentEvents } from '../../../../global/interfaces/component.interface';

const EVENT_PREFIX = 'OrganismVideoEvents__';


/** The type of custom events emitted */
export type OrganismVideoEventTypes = {
	iframeAPIReady: true;
	stopAll: true;
	pauseAll: true;
};

/** The event names for the above events */
export const OrganismVideoEvents: ComponentEvents<OrganismVideoEventTypes> = {
	iframeAPIReady: EVENT_PREFIX + 'IframeAPIReady',
	/** Event for listening out for "stop all" video events on the window */
	stopAll: EVENT_PREFIX + 'StopAll',
	/** Event for listening out for "pause all" video events on the window */
	pauseAll: EVENT_PREFIX + 'PauseAll',
};
